<template>
  <div class="menu-selector">
    <div class="content-wrapper">
      <!-- Left Panel - Menu Items -->
      <div class="left-panel">
        <h1 class="main-title">Vyberte si z ponuky</h1>

        <nav class="menu-navigation">
          <div
            v-for="(item, index) in menuItems"
            :key="index"
            class="menu-item"
            :class="{ active: activeIndex === index }"
            @mouseenter="setActive(index)"
            @click="goTo(item.linkTo)"
          >
            <h2 class="menu-title">{{ item.title }}</h2>
            <div class="menu-divider"></div>
            <p v-if="activeIndex === index" class="menu-description">
              {{ item.description }}
            </p>
          </div>
        </nav>
      </div>

      <!-- Right Panel - Background Images -->
      <div class="right-panel">
        <TransitionGroup name="fade">
          <div
            v-for="(item, index) in menuItems"
            :key="index"
            v-show="activeIndex === index"
            class="background-image"
            :style="{ backgroundImage: `url(${item.image})` }"
          ></div>
        </TransitionGroup>
      </div>
    </div>
  </div>
</template>

<script>
import stvrtImage from '../assets/images/stvrt-mapa.jpg';

export default {
  name: 'RetailRozcestnik',
  data() {
    return {
      activeIndex: 0,
      menuItems: [
        {
          title: 'Pozemky Bory Retail Zone',
          description:
            'Prezrite si ponuku voľných stavebných pozemkov v rámci retailovej zóny na Boroch.',
          image: stvrtImage,
          // môže byť buď route name objekt...
          linkTo: { path: 'retail-zone' }
          // ...alebo path string napr: linkTo: '/pozemky-bory-retail'
        },
        {
          title: 'Obchodné priestory Bory Bývanie',
          description:
            'Prezrite si ponuku voľných obchodných priestorov v rámci obytných domov rezidenčných etáp projektu Bory Bývanie.',
          image: stvrtImage,
          linkTo: { path: 'obchodne-priestory' }
        }
      ]
    };
  },
  methods: {
    goTo(linkTo) {
      if (!linkTo) return;
      this.$router.push(linkTo);
    },
    setActive(index) {
      this.activeIndex = index;
    }
  }
};
</script>

<style scoped>
.menu-selector {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.content-wrapper {
  display: flex;
  height: 100%;
  position: relative;
}

/* Left Panel */
.left-panel {
  width: 33%;
  background: #2d3139;
  padding: 4rem 5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 10;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 900;
  color: #ffffff;
  margin-bottom: 3.5rem;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.menu-navigation {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.menu-item {
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  padding: 0.5rem 0;
}

.menu-title {
  font-family: 'Work Sans', sans-serif;
  font-size: 1.5rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 0.75rem;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  letter-spacing: -0.01em;
}

.menu-item:hover .menu-title,
.menu-item.active .menu-title {
  color: #ffffff;
  transform: translateX(8px);
  font-weight: 700;
}

.menu-divider {
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0.1) 100%
  );
  margin-bottom: 1rem;
  transform-origin: left;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-item.active .menu-divider {
  background: linear-gradient(90deg, #4a90e2 0%, #63b3ed 50%, #4a90e2 100%);
  transform: scaleX(1.1);
  box-shadow: 0 0 12px rgba(74, 144, 226, 0.6);
}

.menu-description {
  font-size: 0.95rem;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.6;
  padding-left: 8px;
  margin-top: 0.5rem;
}

/* Right Panel */
.right-panel {
  width: 67%;
  position: relative;
  overflow: hidden;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.background-image::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, #2d3139 0%, transparent 20%);
  pointer-events: none;
}

/* Animations */
.fade-enter-active {
  transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-leave-active {
  transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-enter-from {
  opacity: 0;
}

.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .left-panel {
    width: 50%;
    padding: 3rem;
  }

  .right-panel {
    width: 50%;
  }

  .main-title {
    font-size: 2rem;
  }

  .menu-title {
    font-size: 1.3rem;
  }
}

@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
  }

  .left-panel {
    width: 100%;
    height: 60%;
    padding: 2rem;
  }

  .right-panel {
    width: 100%;
    height: 40%;
  }

  .main-title {
    font-size: 1.8rem;
    margin-bottom: 2rem;
  }

  .menu-title {
    font-size: 1.2rem;
  }

  .menu-navigation {
    gap: 1.5rem;
  }
}
</style>